"use strict";
// Copyright (c) 2024, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSDELIVR = exports.CDNJS = exports.version = void 0;
// this pulls in our package version(s) with a sledgehammer
const versions = (() => {
    const regex = /([0-9]+\.[0-9]+\.[0-9]+)/;
    return Object.entries(require('../../package.json').dependencies)
        .filter(([name, version]) => !name.includes('@types') && version.match(regex))
        .map(([name, version]) => {
        return {
            name,
            version: (version.match(regex) || [])[0]
        };
    })
        .filter(entry => entry.version);
})();
const version = (name) => {
    var _a;
    return (_a = versions.filter(pkg => pkg.name === name)
        .shift()) === null || _a === void 0 ? void 0 : _a.version;
};
exports.version = version;
exports.CDNJS = 'https://cdnjs.cloudflare.com/ajax/libs';
exports.JSDELIVR = 'https://cdn.jsdelivr.net/npm';
//# sourceMappingURL=cdn.js.map